import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import {rbacActions} from "../../../config/rbac/actions.ts";


export const usePageHeaderTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteApplicationProduct)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateApplicationProduct)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return {tools};
};
